<template>
  <div class="parking-empty-state">
    <img
      class="parking-empty-state__icon"
      src="@/assets/img/icons/message.png"
      alt=""
    >
    <div class="parking-empty-state__text">
      <div class="parking-empty-state__title">
        {{ title }}
      </div>
      <div class="parking-empty-state__description">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Пустое состояние раздела умных парковок.
 */
export default {
  name: "ParkingEmptyState",
  props: {
    title: {
      type: String,
      default: "Тут ничего нет",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>
